import { render, staticRenderFns } from "./OtherIncomeMobileTable.vue?vue&type=template&id=20257703&scoped=true"
import script from "./OtherIncomeMobileTable.vue?vue&type=script&lang=js"
export * from "./OtherIncomeMobileTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20257703",
  null
  
)

export default component.exports